export default __webpack_public_path__ + "static/media/iread_22_3.dc27c31f.jpg";